import { jsx } from "react/jsx-runtime";
import { forwardRef, isValidElement } from "react";
import { useTheme } from "@mui/material";
import EzIconFontAwesome from "./Implementations/EzIconFontAwesome/EzIconFontAwesome.es.js";
import EzIconEzCater from "./Implementations/EzIconEzCater/EzIconEzCater.es.js";
import EzIconReactElement from "./Implementations/EzIconReactElement/EzIconReactElement.es.js";
const isFontAwesomeIcon = (object) => Object.prototype.hasOwnProperty.call(object, "icon");
const isEzcaterIcon = (object) => typeof object === "function";
const isSvgIcon = (object) => isValidElement(object);
const EzIcon = forwardRef(
  ({ color = "inherit", icon, size = "medium", ...props }, ref) => {
    var _a;
    const theme = useTheme();
    const iconProps = {
      color,
      fontSize: size === "inherit" ? size : (_a = theme.typography.icon) == null ? void 0 : _a.size[size],
      ref,
      ...props
    };
    if (isFontAwesomeIcon(icon)) return /* @__PURE__ */ jsx(EzIconFontAwesome, { icon, ...iconProps });
    if (isEzcaterIcon(icon)) return /* @__PURE__ */ jsx(EzIconEzCater, { icon, ...iconProps });
    if (isSvgIcon(icon)) return /* @__PURE__ */ jsx(EzIconReactElement, { icon, ...iconProps });
    return null;
  }
);
EzIcon.displayName = "EzIcon";
export {
  EzIcon as default
};
//# sourceMappingURL=EzIcon.es.js.map
